export class RequestWrapper {

  requestList: any[];
  one: any;
  entityName: string;

}
